import { AbstractControl, UntypedFormArray, UntypedFormGroup, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';

import { Injectable } from '@angular/core';
import { PledgeProductRead } from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }

  options: any = {};
  generate(entity: any) {
    let scpis: UntypedFormGroup[] = [];
    const products = entity;

    if (!!products && products?.length) {
      for (let scpi of products) {
        const parametersGroup = this.formBuilder.group({
          hasDiscount: [
            scpi?.parameters?.hasDiscount || false,
            [
              this.prFormService.RefreshEveryValidators([
                'discountType',
                'discountAmount',
                'discountIban',
                'iban',
                'bic',
                'holder',
                'bankName',
              ]),
              Validators.required,
            ],
          ],
          discountType: [
            scpi?.parameters?.discountType || 'DISCOUNT',
            [
              this.prFormService.AddValidatorsBasedOnCondition(
                this.prFormService
                  .isTargetControlValueEqualTo('hasDiscount', val => {
                    return val === true;
                  })
                  .bind(this),
                Validators.required,
              ),
              this.prFormService.RefreshEveryValidators([
                'sponsorEmail',
                'contributorEmail',
                'contributorFirstName',
                'contributorLastName',
              ]),
            ],
          ],
          sponsorEmail: [
            scpi?.parameters?.sponsorEmail ||
              (scpi?.parameters?.discountType === 'PARRAINAGE'
                ? scpi?.parameters?.discountEmail
                : null),
            [
              this.prFormService.AddValidatorsBasedOnCondition(
                this.prFormService
                  .isTargetControlValueEqualTo('hasDiscount', val => {
                    return val === true;
                  })
                  .bind(this),
                this.prFormService.AddValidatorsBasedOnCondition(
                  this.prFormService
                    .isTargetControlValueEqualTo('discountType', val => {
                      return val === 'PARRAINAGE';
                    })
                    .bind(this),
                  Validators.required,
                ),
              ),
            ],
          ],
          sponsorId: [scpi?.parameters?.sponsorId || null],
          contributorEmail: [
            scpi?.parameters?.contributorEmail ||
              (scpi?.parameters?.discountType === 'APPORTEUR'
                ? scpi?.parameters?.discountEmail
                : null),
            [
              this.prFormService.AddValidatorsBasedOnCondition(
                this.prFormService
                  .isTargetControlValueEqualTo('hasDiscount', val => {
                    return val === true;
                  })
                  .bind(this),
                this.prFormService.AddValidatorsBasedOnCondition(
                  this.prFormService
                    .isTargetControlValueEqualTo('discountType', val => {
                      return val === 'APPORTEUR';
                    })
                    .bind(this),
                  [Validators.required, Validators.email],
                ),
              ),
            ],
          ],
          contributorFirstName: [
            scpi?.parameters?.contributorFirstName ||
              (scpi?.parameters?.discountType === 'APPORTEUR'
                ? scpi?.parameters?.discountFirstname
                : null),
            [
              this.prFormService.AddValidatorsBasedOnCondition(
                this.prFormService
                  .isTargetControlValueEqualTo('hasDiscount', val => {
                    return val === true;
                  })
                  .bind(this),
                this.prFormService.AddValidatorsBasedOnCondition(
                  this.prFormService
                    .isTargetControlValueEqualTo('discountType', val => {
                      return val === 'APPORTEUR';
                    })
                    .bind(this),
                  Validators.required,
                ),
              ),
            ],
          ],
          contributorLastName: [
            scpi?.parameters?.contributorLastName ||
              (scpi?.parameters?.discountType === 'APPORTEUR'
                ? scpi?.parameters?.discountLastname
                : null),
            [
              this.prFormService.AddValidatorsBasedOnCondition(
                this.prFormService
                  .isTargetControlValueEqualTo('hasDiscount', val => {
                    return val === true;
                  })
                  .bind(this),
                this.prFormService.AddValidatorsBasedOnCondition(
                  this.prFormService
                    .isTargetControlValueEqualTo('discountType', val => {
                      return val === 'APPORTEUR';
                    })
                    .bind(this),
                  Validators.required,
                ),
              ),
            ],
          ],
          discountAmount: [
            scpi?.parameters?.discountAmount || 0,
            [
              this.prFormService.AddValidatorsBasedOnCondition(
                this.prFormService
                  .isTargetControlValueEqualTo('hasDiscount', val => {
                    return val === true;
                  })
                  .bind(this),
                [Validators.required, Validators.min(1)],
              ),
            ],
          ],
          discountEmail: [scpi?.parameters?.discountEmail || null],
          discountFirstname: [scpi?.parameters?.discountFirstname || null],
          discountLastname: [scpi?.parameters?.discountLastname || null],
          discountIban: this.formBuilder.group({
            id: [scpi?.parameters?.discountIban?.id || null],
            iban: [
              scpi?.parameters?.discountIban?.iban || null,
              [
                this.prFormService.AddValidatorsBasedOnCondition(
                  (ctrl: AbstractControl) =>
                    ctrl?.parent?.parent?.get('hasDiscount')?.value === true,
                  Validators.required,
                ),
              ],
            ],
            bic: [
              scpi?.parameters?.discountIban?.bic || null,
              [
                this.prFormService.AddValidatorsBasedOnCondition(
                  (ctrl: AbstractControl) =>
                    ctrl?.parent?.parent?.get('hasDiscount')?.value === true,
                  Validators.required,
                ),
              ],
            ],
            holder: [
              scpi?.parameters?.discountFirstname &&
              scpi?.parameters?.discountLastname
                ? `${scpi?.parameters.discountFirstname} ${scpi?.parameters.discountLastname}`
                : scpi?.parameters?.discountIban?.holder || null,
              [
                this.prFormService.AddValidatorsBasedOnCondition(
                  (ctrl: AbstractControl) =>
                    ctrl?.parent?.parent?.get('hasDiscount')?.value === true,
                  Validators.required,
                ),
              ],
            ],
            bankName: [
              scpi?.parameters?.discountIban?.bankName || null,
              [
                this.prFormService.AddValidatorsBasedOnCondition(
                  (ctrl: AbstractControl) =>
                    ctrl?.parent?.parent?.get('hasDiscount')?.value === true,
                  Validators.required,
                ),
              ],
            ],
          }),
        });

        const formConfig: FormConfig<PledgeProductRead & { parameters: any }> =
          {
            id: [scpi.id],
            type: [scpi.type],
            productId: [scpi.productId],
            productName: [scpi.productName],
            status: [scpi.status],
            parameters: parametersGroup,
          };

        const formBuilderGroup = this.formBuilder.group(formConfig, {});
        scpis.push(formBuilderGroup);
      }
    }

    let group = this.formBuilder.group({
      scpis: this.formBuilder.array(scpis, Validators.nullValidator),
    });

    this.form = group;

    return group;
  }
  get scpis() {
    return this.form.get('scpis') as UntypedFormArray;
  }
  extract() {
    const formValue = _.cloneDeep(this.form.value.scpis);
    return { products: formValue };
  }
}
